import initialState from './initialState.js'

export const resetState = (state) => {
  const s = initialState()

  Object.keys(s).forEach(key => {
    state[key] = s[key]
  })
}

export const setNamedLocations = (state, named_locations) => {
  state.namedLocations = named_locations
}

export const addNamedLocation = (state, named_locations) => {
  state.namedLocations.push(named_locations)
}

export const updateNamedLocation = (state, named_locations) => {
  state.namedLocations = state.namedLocations.filter(location => {
    return location.id !== named_locations.id
  })

  state.namedLocations.push(named_locations)
}

export const removeNamedLocation = (state, named_location_id) => {
  state.namedLocations = state.namedLocations.filter(location => location.id !== named_location_id)
}

export const setAlertSettings = (state, alert_settings) => {
  state.alertSettings = alert_settings
}

export const updateAlertSettiings = (state, alert_settings) => {
  alert_settings.forEach(setting => {
    state.alertSettings.filter(stored_setting => stored_setting.id !== setting.id)
    state.alertSettings.push(setting)
  })
}

export const setLocationHistory = (state, location_history) => {
  state.locationHistory = state.locationHistory.concat(location_history)
}

export const clearLocationHistory = (state) => {
  state.locationHistory = []
}